'use strict';


export default function() {
	return function filter(obj) {
		try {
			return Object.keys(obj).length;
		} catch(e) {
			return;
		}
	}
}
